'use client';

import styles from './Coverage.module.css';

const regions = [
    {
        icon: '🏝️',
        name: 'Sumatera',
        subtext: '10 Provinsi',
        cities: ['Medan', 'Padang', 'Palembang', 'Pekanbaru', 'Banda Aceh', 'Jambi', 'Lampung', 'Bengkulu'],
    },
    {
        icon: '🏙️',
        name: 'Jawa',
        subtext: '6 Provinsi',
        cities: ['Jakarta', 'Surabaya', 'Bandung', 'Semarang', 'Yogyakarta', 'Solo', 'Malang', 'Cirebon'],
    },
    {
        icon: '🌴',
        name: 'Kalimantan',
        subtext: '5 Provinsi',
        cities: ['Pontianak', 'Banjarmasin', 'Samarinda', 'Balikpapan', 'Palangkaraya', 'Tarakan'],
    },
    {
        icon: '⛰️',
        name: 'Sulawesi',
        subtext: '6 Provinsi',
        cities: ['Makassar', 'Manado', 'Palu', 'Kendari', 'Gorontalo', 'Mamuju'],
    },
    {
        icon: '🏖️',
        name: 'Bali & Nusa Tenggara',
        subtext: '3 Provinsi',
        cities: ['Denpasar', 'Mataram', 'Kupang', 'Labuan Bajo', 'Bima', 'Sumbawa'],
    },
    {
        icon: '🌊',
        name: 'Maluku & Papua',
        subtext: '6 Provinsi',
        cities: ['Ambon', 'Ternate', 'Jayapura', 'Sorong', 'Manokwari', 'Merauke'],
    },
];
import dynamic from 'next/dynamic';

// Dynamically import the map to avoid SSR "window not defined" errors
const CoverageMap = dynamic(() => import('./CoverageMap'), {
    ssr: false,
    loading: () => (
        <div className={styles.mapLoading}>
            Loading Interactive Map...
        </div>
    )
});

export default function Coverage() {
    return (
        <section id="jangkauan" className={`section ${styles.coverage}`}>
            <div className="container">
                <div className="section-header reveal">
                    <span className="section-label">Jangkauan Kami</span>
                    <h2 className="section-title">Seluruh Nusantara Terjangkau</h2>
                    <p className="section-subtitle">
                        Jaringan kami mencakup seluruh wilayah Indonesia, dari Sabang sampai Merauke.
                    </p>
                </div>

                <div className={`${styles.mapWrapper} reveal`}>
                    <CoverageMap />
                </div>

                <div className={`${styles.coverageBanner} reveal`}>
                    <div className={styles.bannerContent}>
                        <h3 className={styles.bannerTitle}>Tidak menemukan kota tujuan Anda?</h3>
                        <p className={styles.bannerSubtitle}>
                            Hubungi kami untuk pengecekan rute dan estimasi biaya pengiriman.
                        </p>
                    </div>
                    <div className={styles.bannerAction}>
                        <a href="#kontak" className="btn btn-primary">
                            Cek Jangkauan
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
